export const callSocket = (obj, callback = () => {}, error = () => {}) => {
   window.socket.send(obj, (resultStatus) => {
      if (resultStatus?.settings?.status === 1) {
         callback(resultStatus);
      } else {
         error(resultStatus);
      }
   });
};
